import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { SetCardLimitStackRoutes, SetCardLimitStackScreenProps } from './type';
import { PlacedScreen } from './Placed.screen';
import { PlacedNativeScreen } from './PlacedNative.screen';

export interface SetCardLimitProps {}
export const SetCardLimitPlaced: React.FC<SetCardLimitStackScreenProps<SetCardLimitStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, record, dailyLimitType, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <PlacedNativeScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        account={account}
        tab={tab}
        record={record}
        dailyLimitType={dailyLimitType}
        returnData={returnData}
        refresh={refresh}
      />
    );
  }

  return (
    <PlacedScreen
      onClose={onGoBack}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      record={record}
      dailyLimitType={dailyLimitType}
      returnData={returnData}
      refresh={refresh}
    />
  );
};
